module.exports = __webpack_public_path__ + "img/lift-panel.fdefae91.jpg";